import React from "react";
import { LinkItem } from "../LinkItem";
import { isFullUrl } from "../../../../utils/validators";
import Link from "next/link";

type AnchorItemProps = {
  link: LinkItem;
  itemId: string;
};

export const AnchorItem: React.FunctionComponent<AnchorItemProps> = ({
  link,
  itemId,
}): React.ReactElement => {
  return (
    <div tabIndex={0} key={link.anchor} className="menu-item">
      {isFullUrl(link.url) ? (
        <a href={link.url} target={link.target}>
          {link.anchor}
        </a>
      ) : (
        <Link tabIndex={0} href={link.url} passHref target={link.target}>
          {link.anchor}
        </Link>
      )}
    </div>
  );
};
